import React, { useState, } from 'react';
import { UserList } from '../Admin/userManagement/UserList';
import { SearchUser } from '../Admin/userManagement/SearchUser';
import ObjCommonFilterSelection from 'src/component/custom/ObjCommonFilterSelection';
import AccountList from '../Admin/Accounts/AccountList';
import { SearchAcct } from '../Admin/Accounts/SearchAcct';
import AdminConsoleHeader from '../Admin/AdminConsoleHeader';
import AdminConfig from "@system/config/admin";
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import { useObjCommonFilterStore } from 'src/hooks/objCommonFilter';
import { useAccountStore } from 'src/hooks/admin/account';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const UserManagementTab = () => {
    const c = System.getParams().tab;
    const [{ }, { }, { set_account_list }] = useAccountStore();
    const { adminConsoleTab: { User, Account }} = Constants
    const [activeTab, setActiveTab] = useState(c ? c : User)
    const [{ }, { }, { clear_all_filter }] = useObjCommonFilterStore();
    const [{ }, { clear_all_system_alert }, { }] = useDOMAttachToSystemStore();

    const onChangeTab = (tab) => {
        set_account_list()
        clear_all_filter()
        clear_all_system_alert({});
        setActiveTab(tab)
        let newUrl = AdminConfig.getAdminURL() + '?tab=' + tab;
        window.history.pushState({ path: newUrl }, '', newUrl);
    }

    return (
        <>
            <div className='adminconsole-container'>
                <AdminConsoleHeader title={activeTab === User ? 'USER MANAGEMENT' : activeTab == Account ? 'ACCOUNT MANAGEMENT' : 'REPORT MANAGEMENT'} tab={activeTab} />

                <div className='adminuser-tabs'>
                    <div className='container'>
                        <ul className="bs5 nav nav-tabs">
                            <li>
                                <a className={"text-uppercase font-bold " + (activeTab === User ? 'active' : '')} onClick={() => onChangeTab(User)}><span>USERS</span></a>
                            </li>
                            <li>
                                <a className={"text-uppercase font-bold " + (activeTab === Account ? 'active' : '')} onClick={() => onChangeTab(Account)}><span>ACCOUNTS</span></a>
                            </li>
                        </ul>
                    </div>
                </div>
                {activeTab === User ?
                    <div>
                        <div className='acsearchuser'>
                            <SearchUser />
                        </div>
                        <ObjCommonFilterSelection />
                        <div>
                            <UserList />
                        </div>
                    </div> :
                    activeTab === Account &&
                    <div>
                        <div className='acsearchuser'>
                            <SearchAcct />
                        </div>
                        <ObjCommonFilterSelection />
                        <div>
                            <AccountList />
                        </div>
                    </div>
                }
            </div>

        </>
    );
}

export default UserManagementTab;